import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import I18n from '../../lib/i18n';
import InlineIconText from './components/InlineIconText/InlineIconText';

const styles = StyleSheet.create({
  text: {
    color: '#404040',
    fontSize: 14,
    fontWeight: '600',
    marginRight: 5,
    marginTop: 15,
  },
});

type Props = {
  customer: Object,
};

const Contacts = (props: Props) => (
  <View>
    <Text style={styles.text}>{I18n.t('contact')}</Text>
    {!!props.customer.contactNumber && <InlineIconText icon="phone" text={props.customer.contactNumber} />}
    {!!props.customer.contactEmail && <InlineIconText icon="sms" text={props.customer.contactEmail} />}
  </View>
);

export default Contacts;
